var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66406 12.0003C6.87273 10.6977 9.10873 10.6363 10.3307 12.0003M9.29073 8.00033C9.29073 8.73699 8.71006 9.33366 7.99273 9.33366C7.27606 9.33366 6.69473 8.73699 6.69473 8.00033C6.69473 7.26366 7.27606 6.66699 7.99273 6.66699C8.7094 6.66699 9.2914 7.26366 9.2914 8.00033",
    stroke: "#767A85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33203 2.66797C4.56936 2.67464 3.62603 2.73597 3.01536 3.31464C2.33203 3.96197 2.33203 5.00397 2.33203 7.08797V10.246C2.33203 12.33 2.33203 13.3726 3.01536 14.0193C3.6987 14.6673 4.7987 14.6673 6.9987 14.6673H8.9987C11.1987 14.6673 12.2987 14.6673 12.982 14.02C13.6654 13.372 13.6654 12.33 13.6654 10.2466V7.08797C13.6654 5.00397 13.6654 3.96197 12.982 3.31464C12.3714 2.73597 11.4287 2.67464 9.66536 2.66797",
    stroke: "#767A85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51319 2.4215C6.57719 2.14483 6.60919 2.00616 6.67053 1.8935C6.74678 1.75944 6.85053 1.64303 6.97496 1.55191C7.0994 1.4608 7.2417 1.39704 7.39252 1.36483C7.52786 1.3335 7.68519 1.3335 7.99853 1.3335C8.31186 1.3335 8.46919 1.3335 8.60453 1.36483C8.75535 1.39704 8.89765 1.4608 9.02209 1.55191C9.14652 1.64303 9.25027 1.75944 9.32652 1.8935C9.38786 2.00683 9.41986 2.14483 9.48386 2.4215L9.53919 2.6615C9.65252 3.1515 9.70919 3.39683 9.62386 3.5855C9.5657 3.71072 9.47114 3.8155 9.35253 3.88616C9.16519 4.00016 8.88653 4.00016 8.33053 4.00016H7.66653C7.11053 4.00016 6.83186 4.00016 6.64452 3.88683C6.52581 3.81599 6.43124 3.71096 6.37319 3.5855C6.28786 3.39683 6.34453 3.15216 6.45786 2.6615L6.51319 2.4215Z",
    stroke: "#767A85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdcard);
export default __webpack_public_path__ + "static/media/idcard.a9f68322aff7183edf84e1704f1e50ad.svg";
export { ForwardRef as ReactComponent };